import axios from 'axios'
import * as ls from "local-storage";
import authInstance from '../Classes/AuthHandler';
import env from '../ENV';
const renewtokenStatus = 406;
class AxiosHandler{
    constructor() { 
        this.authDetails = ls.get("authDetails");
        this.requestInterceptors();
        this.responseInterceptors();
    }

    get = async (endpoint,countVal =1)=>{
        
        var thisInstance = this;
        let res = await axios.get(endpoint).catch(async (err)=>{
            //logic for renew
            if(err.response.status == renewtokenStatus && countVal<2){
                countVal++;
                thisInstance.authDetails = await authInstance.renewToken();
                return thisInstance.get(endpoint,countVal);
            }else{
                return err;
            }
        
        });
        
        return res;
    }

    post= async(endpoint,data,countVal = 1)=>{
        var thisInstance = this;
        let res =  await axios.post(endpoint,data).catch(async (err)=>{
            //logic for renew
            if(err.response.status == renewtokenStatus && countVal<2){
                countVal = countVal +1;
                thisInstance.authDetails = authInstance.renewToken();
                return thisInstance.post(endpoint,data,countVal);
            }else{
                return err;
            }
        
        });

        return res;
    }

    put = async(endpoint,data, countVal =1) =>{
        var thisInstance = this;
        let res =  await axios.put(endpoint,data).catch(async (err)=>{
            //logic for renew
            if(err.response.status == renewtokenStatus){
                countVal = countVal +1;
                thisInstance.authDetails = authInstance.renewToken();
                return thisInstance.put(endpoint,data,countVal);
            }else{
                return err;
            }
        });
        return res;
    }

    patch = async(endpoint,data,countVal =1) =>{
        var thisInstance = this;
        let res =   await axios.patch(endpoint,data).catch(async (err)=>{
            //logic for renew
            if(err.response.status == renewtokenStatus){
                thisInstance.authDetails = authInstance.renewToken();
                return thisInstance.patch(endpoint,data);
            }else{
                return err;
            }
        
        });
        return res;
    }

    requestInterceptors = () =>{
        try{
            var thisIns = this;
            axios.interceptors.request.use(
                function(successfulReq) {
                  let accesstoken = authInstance.getToken();
                  if(accesstoken){
                    successfulReq.headers.Authorization = "Bearer "+ accesstoken; 
                  }
                  
                  return successfulReq;
                }, 
                function(error) {
                  thisIns.manageResponse(error.response)
                  return Promise.reject(error);
                }
              );
        }catch(e){
            console.log("requestInterceptors Error:",e)
        }
    }

    responseInterceptors = () =>{
        try{
            axios.interceptors.response.use(
                function(successfulRes) {
                    // console.log(successfulRes,"successfulRes");
                  return successfulRes;
                }, 
                function(error) {
                    
                  if(error.response.status==403){
                    window.location.href = env.LOGIN_URL;
                  }

                  return Promise.reject(error);
                }
              );
        }catch(e){
            console.log("responseInterceptors Error:",e)
        }
    }

    manageResponse = (response) =>{
        if(response.status==404){
            //redirect to login
        }else if(response.status == 400){
            console.log("API is not working");
        }
    }
}

export default new AxiosHandler();